export function isEmailDomainBlocked(value: string, domains: Array<string>) {
    try {
        const email = value.toLowerCase().split('@')[1];

        return !domains.includes(email);
    } catch (e) {
        return false;
    }
}
